export const de = {
  translation: {
    general: {
      now: 'Jetzt',
    },
    navLeft: {
      home: 'home',
      news: 'news',
      projects: 'projekte',
      aboutme: 'dwain',
      contact: 'kontakt'
    },
    home: {
      title: 'DWAIN',
      subTitle: 'professionell // effizient // sicher',
      counter: {
        experience: {
          count: '16+',
          title: 'Jahre IT Erfahrung'
        },
        codeExperience: {
          count: '6000+',
          title: 'Stunden Programmiererfahrung'
        },
        projects: {
          count: '10+',
          title: 'Erfolgreiche Projekte'
        }
      }
    },
    contact: {
      title: 'In',
      title1: 'Kontakt',
      title2: 'kommen!',
      test: 'sdad',
      subtitle: 'Ich freue mich darauf, mit dir ein Projekt zu starten oder dir bei deinem Probleme helfen zu können',
      form: {
        inputNameplaceholder: 'Geb dein Namen ein',
        inputMailplaceholder: 'Geb deine Email ein',
        inputTextplaceholder: 'Geben deine Nachricht ein',
        enterButton: 'Senden'
      }
    },
    me: {
      infoText1: 'Ich bin seit meinem 14. Lebensjahr ein leidenschaftlicher Computer Nerd. Meine Begeisterung für Technologie begann früh, als ich meine ersten Webseiten baute – ganz oldschool, pure HTML/CSS. Diese ersten Schritte waren der Beginn einer Reise, die mich tief in die Welt der Informatik führte.',
      infoText2: 'Schon früh kam ich auch mit dem Thema IT-Security in Kontakt. Sicherheitsfragen und das Lösen von Sicherheitsproblemen wurden zu einem wesentlichen Bestandteil meiner Interessen.',
      infoText3: 'Was mich von Anfang an faszinierte, war die Herausforderung, Probleme zu lösen. Für mich gab es kein Problem, das nicht zu bewältigen war.',
      infoText4: 'Neben der Programmierung habe ich mich auch intensiv mit 3D-Software und Bildbearbeitung beschäftigt. Diese kreativen Bereiche haben mir nicht nur geholfen, ein breites Spektrum an technischen Fähigkeiten zu entwickeln, sondern auch meine Kreativität und mein ästhetisches Verständnis geschärft.',
      infoText5: 'Computerspiele gehören ebenfalls zu meinen Hobbys. Die Kombination aus Problemlösung und spielerischer Kreativität hat meine Leidenschaft für die Softwareentwicklung weiter befeuert. Heute bin ich ein passionierter Softwareentwickler und freue mich jeden Tag aufs Neue, innovative Lösungen zu entwickeln und komplexe Herausforderungen zu meistern.',
      card: {
        '2018': {
          position: 'Developer',
          text: 'Entwicklung & Planung diverser Tools'
        },
        '2016': {
          position: 'Owner',
          text: 'Newsseite rund um Sandbox Spiele'
        },
        '2013': {
          position: 'Owner',
          text: 'Community Fanpage über das MMORPG Blackdesert'
        },
        '2011': {
          position: 'Owner',
          text: 'Community Fanpage über das MMORPG ArcheAge'
        }
      }
    },
    error: {
      title: 'SEITE NICHT GEFUNDEN'
    },
    'Welcome to React': 'Willkommen to React and react-i18next'
  }
}